"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = exports.linkAction = void 0;

var _icons = require("../../assets/icons");

var _base = require("./base");

var _sharing_helper = require("../../helpers/sharing_helper");

var linkAction = function linkAction(_ref) {
  var shareUrl = _ref.shareUrl,
      utmParams = _ref.utmParams;
  (0, _sharing_helper.copyToClipboard)("".concat(shareUrl).concat((0, _sharing_helper.toQuery)(utmParams || {})));
};

exports.linkAction = linkAction;
var LinkButton = (0, _base.buildShareButtonComponent)({
  action: linkAction,
  ariaLabel: 'ShareLink',
  buttonLabel: 'Link',
  className: 'share-button--share-link',
  icon: _icons.LinkIcon
});
exports.LinkButton = LinkButton;